// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BEHV","type":"styles_type__2xs_C","choices":"styles_choices__8hof2"};